<template>
  <teleport to="#debug">
    <ul
      v-if="!hidden"
      :class="{
        [$style.bar]: true,
        [$style[`bar--development`]]: ENV === 'development',
        [$style[`bar--alpha`]]: ENV === 'alpha',
        [$style[`bar--demo`]]: ENV === 'demo',
        [$style[`bar--production`]]: ENV === 'production',
      }"
      @click="clicked = true"
    >
      <li :class="[$style.bar__data, $style['bar__data--env']]">
        {{ ENV }} 環境
      </li>
      <li :class="$style.bar__data" v-if="VERSION">version: {{ VERSION }}</li>
    </ul>
  </teleport>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'

const clicked = ref(false)

const ENV = import.meta.env.MODE
const VERSION = process.env.APP_VERSION ?? 'UNKNOWN'

const hidden = computed((): boolean => ENV === 'production' || clicked.value)
</script>

<style lang="scss" module>
.bar {
  position: fixed;
  z-index: 999;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  margin: 0;
  box-shadow: $shadow-4;
  cursor: pointer;
  font-size: 12px;
  opacity: 0.8;

  &--development {
    background-color: $color-label-blue;
  }

  &--alpha {
    background-color: $color-label-green;
  }

  &--demo {
    background-color: $color-label-yellow;
  }

  &--production {
    display: none;
  }

  &__data {
    flex: 0 1 auto;
    margin: 0 8px;
    color: $color-text-and-object-high-emphasis-inverse;
    list-style: none;
    overflow-wrap: break-word;

    &--env {
      font-weight: bold;
    }
  }
}
</style>
